import api from "../../../api";

const BASE = "api/prospecting-reports";

// ---------------------------------------------------------------- wizard data
// Comparable search. `kind` is one of sold | for_sale | leased | for_rent.
// Params: suburb, state, property_type, beds_min/max, baths_min/max,
// cars_min/max, price_min/max, radius_km, lat, lng, q, limit.
export const searchComparables = (params = {}) =>
  api.get(`${BASE}/comparables/`, { params });

export const getSuburbInsights = (params = {}) =>
  api.get(`${BASE}/suburb-insights/`, { params });

// Suggested sale range from the prices the agent selected.
export const getPriceIndication = (prices = []) =>
  api.post(`${BASE}/price-indication/`, { prices });

// ------------------------------------------------------------------------ CMA
export const getCmaReports = (params = {}) => api.get(`${BASE}/cma/`, { params });

export const getCmaReport = (id) => api.get(`${BASE}/cma/${id}/`);

export const createCmaReport = (data) => api.post(`${BASE}/cma/`, data);

export const updateCmaReport = (id, data) => api.patch(`${BASE}/cma/${id}/`, data);

export const deleteCmaReport = (id) => api.delete(`${BASE}/cma/${id}/`);

// Whole-list replace: the wizard step is a selection, so we send the final set.
export const setCmaComparables = (id, comparables) =>
  api.put(`${BASE}/cma/${id}/comparables/`, { comparables });

export const sendCmaReport = (id, data) => api.post(`${BASE}/cma/${id}/send/`, data);

// Results Summary + Select Records tabs, run from the report's Search Options.
export const getCmaRecords = (id) => api.get(`${BASE}/cma/${id}/records/`);

// Property Price Statement only: puts it on its public link once the form passes.
export const publishCmaReport = (id) => api.post(`${BASE}/cma/${id}/publish/`);

// Files the report's PDF into its property's Documents tab.
export const saveCmaToProperty = (id) => api.post(`${BASE}/cma/${id}/save-to-property/`);

// Returns a PDF blob — the caller is responsible for the object URL.
export const downloadCmaPdf = (id) =>
  api.get(`${BASE}/cma/${id}/pdf/`, { responseType: "blob" });

// --------------------------------------------------- market update templates
export const getMarketUpdateTemplates = (params = {}) =>
  api.get(`${BASE}/market-update/templates/`, { params });

export const getMergeTags = () => api.get(`${BASE}/market-update/templates/merge-tags/`);

export const createMarketUpdateTemplate = (data) =>
  api.post(`${BASE}/market-update/templates/`, data);

export const updateMarketUpdateTemplate = (id, data) =>
  api.patch(`${BASE}/market-update/templates/${id}/`, data);

export const deleteMarketUpdateTemplate = (id) =>
  api.delete(`${BASE}/market-update/templates/${id}/`);

// System templates are read-only; this is the only way to start from one.
export const duplicateMarketUpdateTemplate = (id, data = {}) =>
  api.post(`${BASE}/market-update/templates/${id}/duplicate/`, data);

// ----------------------------------------------------- market update reports
export const getMarketUpdateReports = (params = {}) =>
  api.get(`${BASE}/market-update/reports/`, { params });

export const createMarketUpdateReport = (data) =>
  api.post(`${BASE}/market-update/reports/`, data);

export const updateMarketUpdateReport = (id, data) =>
  api.patch(`${BASE}/market-update/reports/${id}/`, data);

export const deleteMarketUpdateReport = (id) =>
  api.delete(`${BASE}/market-update/reports/${id}/`);

// Pass force: true to deliberately send a second time — the API returns 409
// otherwise, so a double-click can never fan out to a client list twice.
export const sendMarketUpdate = (id, recipients, options = {}) =>
  api.post(`${BASE}/market-update/reports/${id}/send/`, { recipients, ...options });

// ------------------------------------------ property market update (Ignite flow)
// The agent's own Pipeline + Database owners. Params: source (all|pipeline|database),
// q, limit, offset.
export const getMarketUpdateContacts = (params = {}) =>
  api.get(`${BASE}/market-update/contacts/`, { params });

// Start a report for one contact: { source_type, source_id } or
// { source_type: "manual", full_address, suburb, state, postcode }.
export const createPropertyMarketUpdate = (data) =>
  api.post(`${BASE}/market-update/reports/`, { kind: "property", ...data });

export const getMarketUpdateReport = (id) =>
  api.get(`${BASE}/market-update/reports/${id}/`);

// The email HTML, SMS text and send history. withSender asks which number the
// texts would come from (a live provider call, so only the send step uses it).
export const getMarketUpdatePreview = (id, { withSender = false } = {}) =>
  api.get(`${BASE}/market-update/reports/${id}/preview/`, {
    params: withSender ? { with_sender: 1 } : {},
  });

// { channels: ["sms","email"], vendor_indexes, sms_message, subject, force }
export const sendPropertyMarketUpdate = (id, data) =>
  api.post(`${BASE}/market-update/reports/${id}/send/`, data);

// ------------------------------------------------------------ public (no auth)
// Hit by the vendor's browser from the emailed link. No token is required, and
// none should be sent — the share token in the URL is the credential.
export const getPublicCmaReport = (token) => api.get(`${BASE}/public/cma/${token}/`);

export const downloadPublicCmaPdf = (token) =>
  api.get(`${BASE}/public/cma/${token}/pdf/`, { responseType: "blob" });

export const getPublicMarketUpdate = (token) =>
  api.get(`${BASE}/public/market-update/${token}/`);
